import { gql } from "graphql-tag"

const screenshot = gql`
  enum ScreenshotMetadataField {
    ALTERNATIVE_TEXT
    CAPTION
  }

  input GenerateScreenshotMetadataFieldInput {
    contentId: ID
    field: ScreenshotMetadataField!
    id: ID
    imdbId: String
    originalUrl: String!
    releaseDate: String
    title: String
  }

  type ScreenshotMetadataFieldResponse {
    field: ScreenshotMetadataField!
    value: String!
  }

  input ScreenshotAddInput {
    caption: String
    contentId: ID
    credit: String
    originalUrl: String
  }

  input ScreenshotUpdateInput {
    alternativeText: String
    caption: String
    contentId: ID
    credit: String
    id: ID
    originalUrl: String
  }
`

export default screenshot
